import React from "react";
import {BrowserRouter as Router, Navigate, Route, Routes} from "react-router-dom";
import Login from "./components/Login";
import DashboardLayout from "./components/DashboardLayout";
import Dashboard from "./pages/Dashboard";
import Analytics from "./pages/Analytics";
import Seller from "./pages/Seller";
import OrderHistory from "./pages/OrderHistory";
import {Toaster} from "sonner";
import {AuthProvider} from './Context/AuthContext';
import AuditOrder from "./pages/AuditOrder";
import Currency from "./pages/Currency";
import PricingPlans from "./pages/PricingPlans";
import PaymentSettings from "./pages/PaymentSettings";



function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Toaster richColors position="top-right" />

          <Routes>
            <Route path={'/'} element={<Navigate to={'/center/login'} replace/>}/>

            {/* Super-admin routes (this app is the marketplace admin console only) */}
            <Route path="/center">
              {/* Public auth route */}
              <Route path="login" element={<Login />} />

              {/* Dashboard-protected routes under layout */}
              <Route element={<DashboardLayout />}>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="analytics" element={<Analytics />} />
                <Route path="seller" element={<Seller />} />
                <Route path="currency" element={<Currency />} />
                <Route path="pricing-plans" element={<PricingPlans />} />
                <Route path="payment-settings" element={<PaymentSettings />} />
                <Route path="order/:sellerId" element={<OrderHistory />} />
                <Route path="audit/:sellerId" element={<AuditOrder />} />

              </Route>
            </Route>
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
